<div class="week-names-tiles" data-testid="week-names">
    @if (showWeekNumber) {
        <div class="week-number-tile"></div>
    }
    @for (dayOfWeekName of getDayOfWeekNames(); track dayOfWeekName) {
        <div
            class="week-name-tile"
            data-testid="week-name"
            [class.week-name-workingdays-only]="!showWeekends"
            [class.week-name-workingdays-only-with-week-number]="showWeekNumber">
            {{ dayOfWeekName }}
        </div>
    }
</div>
<div class="days-tiles" data-testid="day-tiles">
    @for (tile of tiles; track tile.date; let i = $index) {
        @if (showWeekNumber && i % (showWeekends ? 7 : 5) == 0) {
            <div data-testid="week-number" class="week-number-tile">{{ tile.week }}</div>
        }
        <div
            #tileRef
            class="day-tile"
            data-testid="day-tile"
            [class.day-tile-workingdays-only]="!showWeekends"
            [class.day-tile-workingdays-only-with-week-number]="showWeekNumber"
            [class.day-tile-6weeks]="weeks == 6">
            <div>
                @if (!tile.isToday) {
                    <button mat-button class="day-tile-title day-tile-button" data-testid="day-tile-number">
                        {{ tile.text }}
                    </button>
                }
                @if (tile.isToday) {
                    <button
                        mat-raised-button
                        class="day-tile-title day-tile-button"
                        data-testid="day-tile-number-today"
                        color="primary">
                        {{ tile.text }}
                    </button>
                }
            </div>
            @if (isLoading) {
                <div class="day-tile-loading" data-testid="day-tile-loading">
                    <div>
                        <ngx-skeleton-loader
                            [theme]="{ width: '12px', height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                    <div>
                        <ngx-skeleton-loader
                            [theme]="{ width: '30px', height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                    <div class="desc">
                        <ngx-skeleton-loader [theme]="{ height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                </div>
            }
            @if (!isLoading) {
                @for (doc of showTileDocs(tile.docs); track doc) {
                    <app-calendar-doc-mini
                        [doc]="doc"
                        [screenFields]="screenFields"
                        [actions]="actions"></app-calendar-doc-mini>
                }
                @if (getMoreTileDocsNumber(tile.docs); as n) {
                    <div class="day-tile-more" data-testid="day-tile-doc-more">
                        <button
                            mat-button
                            class="more day-tile-button"
                            data-testid="day-tile-doc-more-button"
                            #btMore
                            (click)="more(tile, btMore)">
                            {{ "MODULE_INSTANCE_CALENDAR.N_MORE" | translate: { n: n } }}
                        </button>
                    </div>
                }
            }
        </div>
    }
</div>
